import React, { useState, useRef, } from 'react';

import Loader from 'react-loader-spinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp, faAngleDown, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { withFirebase } from '../firebase';

import data from '../../constants/tournament.json';
import ModalConfirmCustom from '../useful/ModalConfirmCustom';

const TournamentListForm = (props) => {

    const { countText } = props;

    const [saving, setSaving] = useState(false)
    const [isFormShow, setIsFormShow] = useState(false);
    const [confirmShow, setConfirmShow] = useState(false);

    const { _gender, _format, _type } = data;

    const [title, setTitle] = useState('');
    const [gender, setGender] = useState(Object.keys(_gender)[0]);
    const [format, setFormat] = useState(Object.keys(_format)[0]);
    const [type, setType] = useState(Object.keys(_type)[0]);

    const accordionBtn = useRef();

    const handleShowForm = () => {
        setIsFormShow(!isFormShow)
        setTitle('');
        setGender(Object.keys(_gender)[0]);
        setFormat(Object.keys(_format)[0]);
        setType(Object.keys(_type)[0]);
    }

    const hideForm = () => {
        try {
            if (isFormShow) {
                accordionBtn.current.click();
            }
        } catch (error) { }
    }

    const invalid = title === '';

    const onSubmit = (e) => {
        e.preventDefault();
        setConfirmShow(true);
    }

    const addTournament = () => {
        setConfirmShow(false);
        if (!invalid && !saving) {
            setSaving(true);

            const createTournament = props.firebase.createTournament();
            createTournament({
                createdAt: props.firebase.timestamp(),
                title: title,
                gender: gender,
                type: type,
                format: format
            })
                .then((result) => {
                    setSaving(false);
                    if (result.data && result.data.code && result.data.code === 200) {
                        hideForm();
                        // props.showModal("Información", "El Torneo se creó con éxito.");
                    } else {
                        props.showModal("Error", "No se pudo crear el Torneo: " + title);
                    }
                })
                .catch((error) => {
                    console.log("Error: ", error);
                    setSaving(false);
                    props.showModal("Error", "No se pudo crear el Torneo");
                });
        }
    }

    const textButtom = isFormShow ? 'Ocultar' : 'Añadir Torneo';
    const iconButton = isFormShow ? faAngleUp : faAngleDown;

    return (
        <div className="bg-white border rounded-lg accordion p-2" id="accordionOfferForm">
            <div className="nav justify-content-between align-items-center">
                <h6 className="font-weight-bolder m-0">Listado de torneos{countText}</h6>
                <button ref={accordionBtn} onClick={handleShowForm} className="btn btn-second btn-sm" type="button" data-toggle="collapse" data-target="#offerFormCollapse" aria-expanded="true" aria-controls="offerFormCollapse">
                    <span className="mr-2 d-none d-md-inline">{textButtom}</span>
                    <FontAwesomeIcon className="" icon={iconButton} />
                </button>
            </div>
            <div id="offerFormCollapse" className="collapse hide" data-parent="#accordionOfferForm">
                <div className="pt-2 pl-2 pr-2">
                    {/* <span className="font-weight-bolder ml-2">Crear Nuevo Torneo</span> */}

                    <form onSubmit={onSubmit}>

                        <div className="row m-0">
                            <div className="col row pl-0 pr-0 m-0">

                                <div className="col-12 col-sm-6 col-md-4 p-1">
                                    <label className="small text-secondary mb-0 ml-1" htmlFor="title">Nombre del Torneo:</label>
                                    <input className="form-control form-control-sm" value={title} type="text" onChange={(e) => setTitle(e.target.value)} id="title" name="title" placeholder="..." />
                                </div>

                                <div className="col-4 col-sm-6 col-md-3 p-1">
                                    <label className="small text-secondary mb-0 ml-1" htmlFor="gender">Género:</label>
                                    <select value={gender} onChange={(e) => setGender(e.target.value)} className="form-control form-control-sm" id="gender">
                                        {Object.keys(_gender).map((key) =>
                                            <option key={key} value={key}>{_gender[key]}</option>)
                                        }
                                    </select>
                                </div>

                                <div className="col-4 col-sm-6 col-md-3 p-1">
                                    <label className="small text-secondary mb-0 ml-1" htmlFor="format">Tipo:</label>
                                    <select value={format} onChange={(e) => setFormat(e.target.value)} className="form-control form-control-sm" id="format">
                                        {Object.keys(_format).map((key) =>
                                            <option key={key} value={key}>{_format[key]}</option>)
                                        }
                                    </select>
                                </div>

                                <div className="col-4 col-sm-6 col-md-2 p-1">
                                    <label className="small text-secondary mb-0 ml-1" htmlFor="type">Modalidad:</label>
                                    <select value={type} onChange={(e) => setType(e.target.value)} className="form-control form-control-sm" id="type">
                                        {Object.keys(_type).map((key) =>
                                            <option key={key} value={key}>{_type[key]}</option>)
                                        }
                                    </select>
                                </div>

                            </div>
                            {(!saving) ?
                                <div className="col-12 row pl-0 pr-0 m-0 justify-content-end">

                                    <button disabled={invalid} type="submit" className="col-auto btn btn-sm btn-success m-1">Guardar</button>
                                </div>
                                :
                                <div className="col-12 row nav justify-content-center">
                                    <Loader className="m-2"
                                        type="ThreeDots"
                                        color="#263238"
                                        height={30}
                                        width={60}
                                        timeout={0} />
                                </div>
                            }
                        </div>
                    </form>
                </div>
            </div>

            {/* TournamentConfirm Modal */}
            <ModalConfirmCustom
                show={confirmShow}
                onClose={() => setConfirmShow(false)}
                onConfirm={addTournament}
            >
                <p className="card-title font-weight-bolder">Crear Nuevo Torneo</p>

                <div className="text-black-50 font-italic small mb-3">
                    <FontAwesomeIcon className="text-break mr-1" icon={faExclamationTriangle} />
                    <span>El campo <strong>"Modalidad"</strong> no podrá ser modificado.</span>
                </div>

                <p className="small card-text text-break">Está seguro que desea crear el torneo?</p>

            </ModalConfirmCustom>

        </div>
    )

}

export default withFirebase(TournamentListForm);
